/*
 * This file is part of glowingblue/newvigation.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import addBlogHero from './addBlogHero';
import alwaysShowDrawerButton from './alwaysShowDrawerButton';
import addTitleToMobileHeader from './addTitleToMobileHeader';
import replaceHeaderPrimary from './replaceHeaderPrimary';
import addCalendarPageHero from './addCalendarPageHero';
import addIndexPageHero from './addIndexPageHero';
import addTagsPageHero from './addTagsPageHero';
import addPollsPageHero from './addPollsPageHero';
import { slug } from '../common';

app.initializers.add(slug, () => {
	addBlogHero();
	alwaysShowDrawerButton();
	addTitleToMobileHeader();
	replaceHeaderPrimary();
	addCalendarPageHero();
	addIndexPageHero();
	addTagsPageHero();
	addPollsPageHero();
});

// Expose compat API
import newvigationCompat from './compat';
import { compat } from '@flarum/core/forum';

Object.assign(compat, newvigationCompat);
